import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const roundShimmerKeyframes = keyframes(["0%{background-position:-40px 0;}100%{background-position:40px 0;}"]);
const StyledRound = styled.div.withConfig({
  displayName: "DataPanelSourceSkeleton__StyledRound",
  componentId: "sc-1f1bsp3-0"
})(["display:inline-block;border-radius:", ";width:20px;height:20px;margin-left:", ";background:linear-gradient( 106deg,", ",", ",", ",", " );animation:", " 15000ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.borderRadius[300], ({
  theme
}) => theme.space[100], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-disabled'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], roundShimmerKeyframes);
const textShimmerKeyframes = keyframes(["0%{background-position:-300px 0;}100%{background-position:300px 0;}"]);
const StyledText = styled.div.withConfig({
  displayName: "DataPanelSourceSkeleton__StyledText",
  componentId: "sc-1f1bsp3-1"
})(["display:inline-block;border-radius:", ";width:150px;height:20px;margin-left:", ";background:linear-gradient( 106deg,", ",", ",", ",", " );animation:", " 15000ms linear 0s infinite normal forwards;"], ({
  theme
}) => theme.borderRadius[300], ({
  theme
}) => theme.space[250], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-disabled'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], textShimmerKeyframes);
const DataPanelSourceSkeleton = () => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": 'data-panel-source-skeleton',
    children: [/*#__PURE__*/_jsx(StyledRound, {}), /*#__PURE__*/_jsx(StyledText, {})]
  });
};
export default DataPanelSourceSkeleton;